<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><span>If anyone finds a resemblance to himself in these pages, fine and dandy, though I can’t imagine who it might be.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?6a39531b